export default function MemoryDotSupport() {
  return (
    <div className="App">
      <h3>Support - Memory Dot Puzzle</h3>
      
      <div style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <h4>Contact Support</h4>
        <p>Need help with Memory Dot Puzzle? We're here to assist you!</p>
        
        <div style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '5px', margin: '20px 0' }}>
          <h5>📧 Email Support</h5>
          <p><strong>Primary:</strong> sainineeraj1234@gmail.com</p>
          <p><strong>Response Time:</strong> Within 24-48 hours</p>
        </div>

        <h4>Frequently Asked Questions</h4>
        
        <div style={{ marginBottom: '20px' }}>
          <h5>Q: What is Memory Dot Puzzle?</h5>
          <p>A: Memory Dot Puzzle is a comprehensive brain training app featuring 5 scientifically-designed cognitive games to improve memory, focus, reaction time, and cognitive flexibility.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: Which game modes are free?</h5>
          <p>A: Memory Grid is completely free with daily challenges and streak tracking. Premium (₹349) unlocks 4 additional games: Reflex Tap, Focus Match, Speed Swipe, and Stroop Test.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: Do I need an internet connection?</h5>
          <p>A: No! Memory Dot Puzzle works completely offline. All your progress and statistics are stored locally on your device. Internet is only needed for purchasing premium features.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: How does Memory Grid work?</h5>
          <p>A: Watch colored dots appear on a grid for a few seconds, then tap the positions where you saw them. You can customize the grid size (3×3 to 6×6), number of dots, and display time.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: What is Reflex Tap?</h5>
          <p>A: Reflex Tap tests your reaction speed. A bunny target 🐰 appears at random positions across the screen. Tap it as quickly as possible! Your reaction time is measured and scored.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: How does Focus Match work?</h5>
          <p>A: Memorize color-symbol pairs, then match them after the symbols shuffle. Tap a symbol, then tap its matching color. Complete all pairs correctly to win!</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: What is Speed Swipe?</h5>
          <p>A: Watch an animated sequence of arrow directions, then repeat the sequence using real swipe gestures. Swipe up, down, left, or right in the correct order.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: What is the Stroop Test?</h5>
          <p>A: A classic cognitive interference test. You'll see color words displayed in different colors. Your task is to select the COLOR of the text, not what the word says.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: Can I adjust game difficulty?</h5>
          <p>A: Yes! Each game has settings with difficulty presets (Easy, Medium, Hard, Expert, Insane) and custom sliders to fine-tune parameters like timing, grid size, and number of rounds.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: What's included in Premium?</h5>
          <p>A: Premium (₹349 lifetime) unlocks all 5 game modes, advanced difficulty levels, detailed statistics dashboard, no advertisements, unlimited retries, and all future updates.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: Is it a one-time purchase or subscription?</h5>
          <p>A: It's a one-time lifetime purchase! Pay once (₹349) and enjoy all premium features forever, including all future updates and new game modes.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: Can I restore my purchase on a new device?</h5>
          <p>A: Yes! Go to Settings → Restore Purchase. Your premium status is linked to your Apple ID or Google Play account.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: What data do you collect?</h5>
          <p>A: We don't collect ANY personal data! All your progress, statistics, and settings are stored locally on your device only. We have no servers tracking your activity.</p>
        </div>

        <h4>Game Features</h4>
        <ul>
          <li>✅ Memory Grid (Free) - Remember colored dot positions</li>
          <li>✅ Reflex Tap (Premium) - Test reaction speed with bunny targets</li>
          <li>✅ Focus Match (Premium) - Match color-symbol pairs</li>
          <li>✅ Speed Swipe (Premium) - Memorize swipe sequences</li>
          <li>✅ Stroop Test (Premium) - Cognitive interference training</li>
          <li>✅ Daily challenges with streak tracking</li>
          <li>✅ Customizable difficulty settings per game</li>
          <li>✅ Dark/Light theme support</li>
          <li>✅ Detailed statistics and analytics</li>
          <li>✅ 100% Offline functionality</li>
        </ul>

        <h4>Technical Support</h4>
        <p>If you're experiencing technical issues:</p>
        <ul>
          <li>Ensure you have the latest app version</li>
          <li>Force quit the app and restart it</li>
          <li>Restart your device</li>
          <li>Clear app cache if problems persist</li>
          <li>For iOS: Check App Store connectivity for purchases</li>
          <li>For Android: Check Google Play Store connectivity for purchases</li>
          <li>Contact us at sainineeraj1234@gmail.com with details</li>
        </ul>

        <h4>Platform Support</h4>
        <ul>
          <li><strong>iOS:</strong> iOS 12.0+ (iPhone/iPad)</li>
          <li><strong>Android:</strong> API 21+ (Android 5.0+)</li>
          <li><strong>Tablet Support:</strong> Optimized for both phones and tablets</li>
          <li><strong>Features:</strong> In-App Purchases, Local Storage, Offline Play</li>
        </ul>

        <h4>Troubleshooting</h4>
        <p><strong>App crashing:</strong> Update to latest version, restart device, clear cache</p>
        <p><strong>Purchase issues:</strong> Check payment in Apple/Google account, try "Restore Purchase" in Settings</p>
        <p><strong>Game too hard/easy:</strong> Tap settings icon (⚙️) during gameplay to adjust difficulty</p>
        <p><strong>Lost streak:</strong> Streaks reset if you miss a day. Play before midnight to maintain streak</p>

        <h4>Feedback & Suggestions</h4>
        <p>We value your feedback! If you have suggestions for new features, game modes, or improvements, please email us at sainineeraj1234@gmail.com</p>

        <div style={{ backgroundColor: '#e8f4fd', padding: '15px', borderRadius: '5px', margin: '20px 0' }}>
          <h5>📱 App Information</h5>
          <p><strong>App Name:</strong> Memory Dot Puzzle</p>
          <p><strong>Developer:</strong> Neeraj Kumar</p>
          <p><strong>Email:</strong> sainineeraj1234@gmail.com</p>
          <p><strong>Platform:</strong> Flutter (iOS & Android)</p>
          <p><strong>Premium Price:</strong> ₹349 (One-time, Lifetime)</p>
        </div>
      </div>
    </div>
  );
}
